var Colors = {
  colorWW000: '#070517',
  colorWW100: '#181877',
  colorWW110: '#3C34E5',
  colorWW120: '#ACD9F3',
  colorWW220: '#B9B1FA',
  colorWW22010: '#EBEBFC',
  colorWW300: '#00351C',
  colorWW310: '#B9B1FA',
  colorWW320: '#CCD7D2',
  colorWW32010: '#E1F1B2',
  colorWW400: '#FE8458',
  colorWW410: '#FFE6DE',
  colorWW420: '#F1E2D1',
  colorWW42010: '#FBF3EB',
  colorWW500: '#FFFFFF',
  colorWW510: '#F4F5F9',
  colorWW530: '#9390AE',
  colorWW560: '#5A577D',
  colorWW600: '#992331',
  colorWW620: '#4F2ACA',
  colorWW700: '#E0F262',
  colorWW720: '#322DA033',
  // 20% opacity
  colorWW730: '#D9D8E3',
  colorWW740: '#5A577D',
  colorWW820: '#F4777F',
  colorWW82010: '#FBF3EB',
  colorWhite: '#FFFFFF',
  colorBlack: '#000000',
  colorBlack200: '#ADABC2',
  colorBluecorn700: '#181877',
  colorRed500: '#DB3347'
};
export default Colors;